import React from 'react';

import { NotFound } from '../components/not-found/not-found';

export function NotFoundPage() {
  return <NotFound message="Page not found" />;
}
